module.exports = __webpack_public_path__ + "img/header-menu-icon10-img.9a475250.png";